var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn/stroke-on-light-navy-envelope-20px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 25",
    d: "M0.5 15V5.10525C0.5 2.58328 2.57231 0.553698 5.09373 0.606228L19.0937 0.897895C21.542 0.948899 23.5 2.94816 23.5 5.39692V15C23.5 17.4853 21.4853 19.5 19 19.5H5C2.51472 19.5 0.5 17.4853 0.5 15Z",
    stroke: "#010620"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 26",
    d: "M0.889648 2.5L9.24689 9.00901C11.1112 10.461 13.7375 10.4096 15.5436 8.88575L23.1119 2.5",
    stroke: "#010620"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.9d8a68df7dcbfe369a7263e41faccb95.svg";
export { ForwardRef as ReactComponent };